//! Importing modules
import React, { useMemo } from "react";
//* Importing hooks
import { Column } from "react-table";
//? Import types
import { TableDragProps, QuestionItem } from "./types/types";
//* Importing components
import { Table } from "./Table";

/**
 * A draggable table component for displaying and managing question items.
 *
 * @param draggable - Enables or disables drag-and-drop functionality for table rows. Defaults to `true`.
 * @param data - The array of question items to be displayed in the table.
 * @param setData - Function to update the table data state.
 * @param showData - Callback to handle the display of specific data items.
 * @param deleteData - Callback to handle the deletion of data items from the table.
 */
export const TableDrag: React.FC<TableDragProps> = ({
  draggable = true,
  data,
  setData,
  showData,
  deleteData,
}) => {
  // Defina as colunas usando as propriedades de QuestionItem
  const columns: Column<QuestionItem>[] = useMemo(
    () => [
      {
        Header: "Enunciado",
        accessor: "enunciado",
      },
      {
        Header: "Disciplina",
        accessor: "disciplina",
      },
      {
        Header: "Tipo de questão",
        accessor: "tipoQuestao",
      },
    ],
    []
  );

  return (
    <Table
      columns={columns}
      draggable={draggable}
      data={data}
      setData={setData}
      showData={showData}
      deleteData={deleteData}
    />
  );
};
